export default "__VITE_ASSET__BoHgXjVc__"